import {
  baseEnumsSelectDictionariesType,
  baseEnumsSelectAreaNo,
  baseEnumsAvaliableTechnicalArea
} from '../api/enumInfo'

/**
 * 获取下拉框选项中的 1：技术领域 2：企业类型 3：员工人数 4：年销售额
 */
function getSelectInfo(type) {
  return new Promise(function (resolve, reject) {
    baseEnumsSelectDictionariesType(type).then(response => {
      if (response.code === 200) {
        resolve((Array.isArray(response.data) && response.data.length ? response.data : []))
      }
    })
  })
}

function getTechnicalArea() {
  return new Promise(function (resolve, reject) {
    getSelectInfo(1).then(response => {
      resolve({
        technicalArea: response
      })
    })
  })
}

function getTechnicalAreaForCompany() {
  return new Promise(function (resolve, reject) {
    baseEnumsAvaliableTechnicalArea().then(response => {
      resolve({
        technicalArea: (Array.isArray(response.data) && response.data.length ? response.data : [])
      })
    })
  })
}

function getEntityType() {
  return new Promise(function (resolve, reject) {
    getSelectInfo(2).then(response => {
      resolve({
        entityType: response
      })
    })
  })
}

function getNumberEmployess() {
  return new Promise(function (resolve, reject) {
    getSelectInfo(3).then(response => {
      resolve({
        numberEmployess: response
      })
    })
  })
}

function getAnnualRevenue() {
  return new Promise(function (resolve, reject) {
    getSelectInfo(4).then(response => {
      resolve({
        annualRevenue: response
      })
    })
  })
}

function getbAreaNo() {
  return new Promise(function (resolve, reject) {
    baseEnumsSelectAreaNo().then(response => {
      resolve({
        headQuarter: response.data
      })
    })
  })
}

function getSelectInfoAll(callback, isListPage) {
  let getTechnicalAreaFun = isListPage ? getTechnicalArea : getTechnicalAreaForCompany 
  Promise.all([getTechnicalAreaFun(), getEntityType(), getNumberEmployess(), getAnnualRevenue(), getbAreaNo()]).then(response => {
    const selectInfoObj = {
      technicalArea: response[0].technicalArea,
      entityType: response[1].entityType,
      numberEmployess: response[2].numberEmployess,
      annualRevenue: response[3].annualRevenue,
      headQuarter: response[4].headQuarter
    }

    if (typeof callback === 'function') {
      callback(selectInfoObj)
    } else {
      return selectInfoObj
    }
  })
}

/**
 * 获取地区名称  返回名称字符串        例：亚洲/中国
 * @param areaStr  地区 code 字符串  例：0010,0011
 * @param AreaSelect 地区国家选择项
 */
function getAreaNoName(areaStr, AreaSelect) {
  const AreaNoNameList = []
  if (areaStr && AreaSelect.length) {
    areaStr = areaStr.split(',')

    const areaInfo = AreaSelect.find(area => {
      return area.areaNo === areaStr[0]
    })
    if (areaInfo) {
      AreaNoNameList.push(areaInfo.name || '')

      const countriesInfo = areaInfo.underCity.find(countries => {
        return countries.areaNo === areaStr[1]
      })
      AreaNoNameList.push(countriesInfo && countriesInfo.name || '')
    }
  }

  return AreaNoNameList.length ? AreaNoNameList.join('/') : []
}

/**
 * 获取下拉选项名称   返回值               例：亚洲/中国
 * @param selectStr 选择项 code 字符串    例：0010,0011
 * @param SelectOpt 选择项
 */
function getSelectName(selectStr, SelectOpt) {
  const selectStrArr = []
  if (selectStr && SelectOpt.length) {
    selectStr = selectStr.split(',')
    selectStr.forEach(str => {
      const strInfo = SelectOpt.find(item => {
        return item.key === str
      })
      selectStrArr.push(strInfo && strInfo.value || '')
    })
  }

  return selectStrArr.length ? selectStrArr.toString() : []
}

export {
  getTechnicalArea,
  getEntityType,
  getNumberEmployess,
  getAnnualRevenue,
  getbAreaNo,
  getSelectInfoAll,
  getAreaNoName,
  getSelectName,
  getTechnicalAreaForCompany
}